export var getFormattedBody = function (features) {
    return features.map(function (params) { return ({
        method: 'abacv2.checkaccess',
        params: params,
    }); });
};
